import React, { Component } from "react";
import PropTypes from "prop-types";

import WindowShade from "shared/payment/components/WindowShade";
import ProductPackageScreen from "../ProductPackageScreen";

import "./index.scss";

export class Boosts extends Component {
	componentWillReceiveProps(nextProps) {
		if (nextProps.isVisible && !this.props.isVisible && !nextProps.productPackages.length) {
			this.props.fetchProductPackages();
		}
	}

	render() {
		const { isVisible, close } = this.props;

		if (!isVisible) {
			return null;
		}

		return (
			<WindowShade
				isVisible={isVisible}
				toggleVisible={close}
			>
				<ProductPackageScreen />
			</WindowShade>
		);
	}
}

Boosts.propTypes = {
	productPackages: PropTypes.array.isRequired,
	isVisible: PropTypes.bool.isRequired,

	close: PropTypes.func.isRequired,
	fetchProductPackages: PropTypes.func.isRequired,
};

export default Boosts;



// WEBPACK FOOTER //
// ./src/apps/boosts/components/Desktop/index.jsx